import React from "react";
import Note from "./Note";
import CreateArea from "./CreateArea";
import Loader from "./Loader";

function Home(props) {
  return (
    <>
      <CreateArea />
      {props.notes.map((noteItem, index) => {
        return (
          <Note
            key={index}
            id={noteItem._id}
            title={noteItem.title}
            content={noteItem.content}
            onDelete={props.deleteNote}
          />
        );
      })}
      <Loader />
    </>
  );
}

export default Home;
